import { render, staticRenderFns } from "./ApiUsage.vue?vue&type=template&id=a2196af6&"
import script from "./ApiUsage.vue?vue&type=script&lang=ts&"
export * from "./ApiUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports